import { Component, OnInit } from '@angular/core';
import {
  Convoy,
  Group,
  Operation,
  Operations,
  Period,
  Periods,
  UnitOperations,
} from './models/dashboard';
import { UnitService } from '../units/services/unit.service';
import { Unit } from '../units/models/unit';
import { last, map, take, tap } from 'rxjs/operators';
import { DashboardService } from './service/dashboard.service';
import { MenuItem, PrimeNGConfig } from 'primeng-lts/api';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  periods: Periods = [];
  period: Period = {
    id: 0,
    name: '',
    start: new Date(),
    end: new Date(),
  };
  limitDate: Date = new Date();
  areDriveTxStatusesDisplayed: boolean = true;
  areDescriptiveGraphicDisplayed: boolean = true;
  arePredictiveGraphicDisplayed: boolean = false;
  allRedy: boolean = false;
  // ------------ test -------------------
  items: MenuItem[] = [
    {
      label: 'Exportar en PDF',
      icon: 'pi pi-file-pdf',
      command: async () => {
        console.log('Export pdf');
        const element = document.getElementById(
          'content-to-export'
        ) as HTMLElement;
        const Images: any[] = [];
        await document.querySelectorAll('canvas').forEach((C) => {
          Images.push(C.toDataURL('image/png'));
        });
        // const canvases = element.querySelectorAll('mileageChartData');

        // canvases.forEach((canvas, i) => {
        //   const _ = canvas.querySelector('canvas');
        //   if (_) {
        //     const imageUrl = _.toDataURL();
        //     const image = new Image();
        //     image.src = imageUrl;

        //     canvas.innerHTML = '';
        //     canvas.appendChild(image);
        //   }
        // });
        const clone = element.cloneNode(true) as HTMLElement;

        console.log('clone', clone.querySelectorAll('canvas').length);
        await clone.querySelectorAll('canvas').forEach((C, i) => {
          const img = new Image();
          img.onload = () => {
            const ctx = C.getContext('2d');
            if (ctx) {
              ctx.drawImage(img, 0, 0);
            }
          };
          img.src = Images[i];
          img.onerror = () => {
            console.error('Error cargando imagen');
          };
        });

        // -------------------------------------------------------------------
        // const sourceElement = document.getElementById(
        //   'content-to-export'
        // ) as HTMLElement;
        // if (!sourceElement)
        //   throw new Error('No se encontró el elemento "content-to-export".');

        // // Convertir todos los canvas a imágenes para que se puedan exportar
        // const chartContainers = sourceElement.querySelectorAll('[data-chart]');

        // chartContainers.forEach((container) => {
        //   const canvas = container.querySelector('canvas') as HTMLCanvasElement;
        //   if (canvas) {
        //     // Crear imagen desde el canvas
        //     const img = document.createElement('img');
        //     img.src = canvas.toDataURL('image/png');
        //     img.style.maxWidth = '100%';
        //     img.style.height = 'auto';

        //     // Reemplazar el canvas con la imagen
        //     container.innerHTML = '';
        //     container.appendChild(img);
        //   }
        // });

        // // Clonar el contenido ya con imágenes
        // const clonedContent = sourceElement.cloneNode(true) as HTMLElement;

        // const tempContainer = document.createElement('div');
        // tempContainer.style.position = 'absolute';
        // tempContainer.style.width = '1920px';
        // tempContainer.style.left = '-9999px'; // Mover fuera de la pantalla
        // tempContainer.appendChild(clonedContent);

        // // Agregar el contenedor temporal al body
        // document.body.appendChild(tempContainer);
        // -------------------------------------------------------------------
        const canvass = document.querySelectorAll('canvas');
        console.log('canvas', canvass.length);

        clone.querySelectorAll('canvas').forEach((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgWidth = 210; // Ancho de A4 en mm
          const pageHeight = 295; // Altura de A4 en mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let position = 0;

          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          // Si el contenido es más largo que una página, agregar páginas adicionales
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }

          // Guardar el PDF
          pdf.save('exported-content.pdf');
        });
        // Capturar el contenido clonado
        // html2canvas(tempContainer, {
        //   scale: 2,
        //   logging: true,
        //   allowTaint: true,
        //   useCORS: true, // Permite el uso de CORS para recursos externos
        //   onclone: (document) => {
        //     // Manipula el documento o aplica los estilos necesarios antes de la captura
        //     const clonedElement = document.getElementById('content-to-export');
        //     if (clonedElement) {
        //       // Aquí puedes aplicar estilos adicionales si es necesario
        //       clonedElement.style.transition = 'all 0.5s ease'; // Ejemplo de estilo
        //     }
        //   },
        // }).then((canvas) => {
        //   const imgData = canvas.toDataURL('image/png');
        //   const pdf = new jsPDF('p', 'mm', 'a4');
        //   const imgWidth = 210; // Ancho de A4 en mm
        //   const pageHeight = 295; // Altura de A4 en mm
        //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
        //   let heightLeft = imgHeight;
        //   let position = 0;

        //   pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        //   heightLeft -= pageHeight;

        //   // Si el contenido es más largo que una página, agregar páginas adicionales
        //   while (heightLeft >= 0) {
        //     position = heightLeft - imgHeight;
        //     pdf.addPage();
        //     pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        //     heightLeft -= pageHeight;
        //   }

        //   // Guardar el PDF
        //   pdf.save('exported-content.pdf');

        //   // Eliminar el contenedor temporal
        //   document.body.removeChild(tempContainer);
        // });
      },
    },
  ];
  listUnitIMEIs: string[] = [];
  operations: UnitOperations = [];

  constructor(
    private unitService: UnitService,
    private dashboardService: DashboardService,
    private primeNGConfig: PrimeNGConfig
  ) {
    this.periods = dashboardService.periods;
    primeNGConfig.setTranslation({
      accept: 'Accept',
      reject: 'Cancel',
      dayNames: [
        'domingo',
        'lunes',
        'martes',
        'miércoles',
        'jueves',
        'viernes',
        'sábado',
      ],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      monthNamesShort: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic',
      ],
      today: 'Hoy',
      clear: 'Limpiar',
      weekHeader: 'Sm',
    });

    dashboardService.getPeriod
      .pipe(
        map((_) => {
          this.period = { ..._ };
        })
      )
      .subscribe();
    this.limitDate.setDate(this.limitDate.getDate() - 90);
  }

  ngOnInit(): void {
    this.dashboardService.getAllRedy
      .pipe(
        tap((_) => {
          if (_) {
            this.allRedy = true;
          }
        })
      )
      .subscribe();
    this.dashboardService.listUnitIMEIs$
      .pipe(
        take(2),
        last(),
        tap((_) => {
          this.listUnitIMEIs = _;
        })
      )
      .subscribe();
    this.dashboardService.operations$
      .pipe(
        take(2),
        last(),
        tap((_) => {
          this.operations = _;
        })
      )
      .subscribe();
  }
  // ----- -----

  setPeriod(period: Period): void {
    // this.period = { ...period };
    this.dashboardService.setPeriod(period);
  }

  checkDates() {
    this.dashboardService.setPeriod({ ...this.period });
    return;
    if (
      Math.abs(this.period.start.getTime() - this.period.end.getTime()) /
        (1000 * 60 * 60) >
      24
    ) {
      const newEnd = new Date(
        this.period.start.getTime() + (1000 * 60 * 60 * 24 - 1000)
      );
      this.dashboardService.setPeriod({ ...this.period, end: newEnd });
    }
  }

  showUnitsTxStates() {
    this.areDriveTxStatusesDisplayed = !this.areDriveTxStatusesDisplayed;
  }
  showDescriptiveGraphic() {
    this.areDescriptiveGraphicDisplayed = !this.areDescriptiveGraphicDisplayed;
  }
  showPredictiveGraphic() {
    this.arePredictiveGraphicDisplayed = !this.arePredictiveGraphicDisplayed;
  }

  onChangeUnitOperation(event: any) {
    this.dashboardService.operation$.next(event.value);
  }
}
